import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import VerifyContractModal from 'VerifyContractModal';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from '../phase_task';

export class VerifyContract extends PhaseTask {
  renderChildren = () =>
    <VerifyContractModal
      phase={this.props.phase}
      task={this.props.task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
      updatePhaseTask={this.props.updatePhaseTask}
    />
}

VerifyContract.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

export const verify_contract = connect(() => ({}), { updatePhaseTask })(VerifyContract);




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/verify_contract/index.jsx